import React from 'react';
import { ScrollView, TouchableOpacity } from 'react-native';

import { Color, CommonStyles } from '../../../styles';
import BaseText from '../../BaseText';
import Icon from '../../Icon';
import AvatarTraveler from './AvatarTraveler';
import { scale } from '../../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../../i18n';

const TravelerList = ({ list, onPress, avatarActionType, enableInvite, onPressInvite }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('TripHubScreen');
  return (
    <ScrollView style={{ height: scale(80) }} horizontal={true}>
      {enableInvite ? (
        <TouchableOpacity
          style={[CommonStyles.ml3, CommonStyles.centerItems]}
          onPress={onPressInvite}
        >
          <>
            <Icon style={{ fontSize: scale(45) }} name="circlePlus" color={Color.primary} />
            <BaseText style={{ color: Color.primary }}>{t(tKey('Invite'))}</BaseText>
          </>
        </TouchableOpacity>
      ) : null}
      {Array.isArray(list) &&
        list.map((item, index) => (
          <TouchableOpacity key={item.name} onPress={() => onPress(item, index)}>
            <AvatarTraveler type={avatarActionType} label={item.name} />
          </TouchableOpacity>
        ))}
    </ScrollView>
  );
};

export default TravelerList;
